
import React from 'react';
import _ from 'lodash';

/// Create Select options from Plan Options
/// @param planOptions object with plan_id as the key. plan_id is numeric
export const PlanSelectOptions = (planOptions, asAdmin) => {
  const selectOptions = [];

  if (!planOptions) {
    return selectOptions;
  }

  _.sortBy(Object.keys(planOptions), key => parseInt(key, 0)).forEach((key) => {
    const planId = parseInt(key, 0);

    if (!asAdmin && (planId < 0 || planId > 4)) {
      return;
    }

    if (planId === 4 && !asAdmin) {
      selectOptions.push((
        <option key={key} value={key} disabled="disabled">{planOptions[key].label} - {planOptions[key].description}</option>
      ));
    } else {
      selectOptions.push((
        <option key={key} value={key}>{planOptions[key].label} - {planOptions[key].description}</option>
      ));
    }
  });
  return selectOptions;
};


/// Create Select options from Stripe Subscription Plan Options
/// @param planOptions object with plan_id as the key
export const StripeSubscriptionPlanSelectOptions = (planOptions) => {
  const selectOptions = [];

  if (!planOptions) {
    return selectOptions;
  }

  _.sortBy(Object.keys(planOptions), key => parseInt(key, 0)).forEach((planId, index) => {
    selectOptions.push((
      <option key={index} value={planId}>{planOptions[planId].label}</option>
    ));
  });
  return selectOptions;
};



// WEBPACK FOOTER //
// ./client/helpers/plan-options.jsx